import React from 'react';
import { BarChart, XAxis, YAxis, CartesianGrid, Bar, ResponsiveContainer, Tooltip, Legend } from 'recharts';

import CustomTooltip from '@hydra/common/criterium/CriteriumChart/components/CustomTooltip';
import { useI18n } from '@hydra/common/customHooks';

export default function CriteriumBarChart ({
  chartData,
  chartOptions,
  hasLegend,
  colors,
  hasTooltip,
  legendFormatter
}: {
  chartData: {
    data: {}[]
    charts: {
      dataKey: string,
      name: string
    }[]
  }
  chartOptions: {
    width: string | number
    height: number
  }
  hasLegend: boolean
  colors: string[]
  hasTooltip: boolean
  legendFormatter?: (value: string) => React.ReactNode
}) {
  const { numeral } = useI18n();
  const { data, charts } = chartData;

  const formatter = (value: number) => numeral(value).format().toString().replace('-', '');

  const labelFormatter = (label: string) => {
    return label;
  };

  return (
    // using width 99% to make container resize properly https://github.com/recharts/recharts/issues/172#issuecomment-307858843
    <ResponsiveContainer {...chartOptions}>
      <BarChart data={data} margin={{ top: 20 }}>
        <XAxis
          axisLine={false}
          tickLine={false}
          dataKey='x'
          xAxisId='m'
        />
        <XAxis
          axisLine={false}
          tickLine={false}
          dataKey='x'
          xAxisId='f'
          hide
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{ transform: 'translate(-5, 0)' }}
          tickFormatter={formatter}
        />
        <CartesianGrid vertical={false} />
        {hasTooltip && (
          <Tooltip
            formatter={formatter}
            labelFormatter={labelFormatter}
            content={<CustomTooltip />}
            cursor={false}
          />
        )}
        {
          charts.map((chart, i) => (
            <Bar
              key={chart.dataKey}
              xAxisId={i === 0 || i === 2 ? 'm' : 'f'}
              dataKey={chart.dataKey}
              name={chart.name}
              fill={colors[i % colors.length]}
              barSize={30}
            />
          ))
        }
        {hasLegend && <Legend wrapperStyle={{ bottom: -10 }} formatter={legendFormatter} />}
      </BarChart>
    </ResponsiveContainer>
  );
}
